import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_METRICS_API } from "./apiRoutes";
interface UseDownloadExcelMetricProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const downloadExcelMetric = async (communityId: string, year: string) =>
  await axiosAuth.get(`${DISTRIBUTION_METRICS_API(communityId)}/weighing-factor/excel-template?year=${year}`, {
    responseType: "blob",
  });

const useDownloadExcelMetric = ({
  queryParams,
  communityId,
  year
}: UseDownloadExcelMetricProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["download-excel-distribution-metric", communityId, year],
    queryFn: () => downloadExcelMetric(communityId, year),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    enabled: queryParams?.enabled,
    ...queryParams,
  });
};

export default useDownloadExcelMetric;
